import { render, staticRenderFns } from "./CommissionData.vue?vue&type=template&id=428c214c"
import script from "./CommissionData.vue?vue&type=script&lang=js"
export * from "./CommissionData.vue?vue&type=script&lang=js"
import style0 from "./CommissionData.vue?vue&type=style&index=0&id=428c214c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports